import ApiClient from './ApiClient';
/* global axios */

// Hora de inicio de jornada · monitoreo (Victor 2026-06-09).
class WorkStartAPI extends ApiClient {
  constructor() {
    super('work_start', { accountScoped: true });
  }

  // ¿Debe salirle el modal hoy? { pending, started_at_label, date_label }
  status() {
    return axios.get(`${this.url}/status`);
  }

  // Registra el "Entendido · iniciar labor" del agente.
  confirm() {
    return axios.post(`${this.url}/confirm`);
  }
}

export default new WorkStartAPI();
